import { useTranslation } from "react-i18next";
import { isMobile } from "../helpers/mobile";
import useFeature from "../hooks/useFeature";

const SwitchToNativeBanner = () => {
  const { t } = useTranslation("authPage");

  const isFeatureEnabled = useFeature("switch-to-native-banner");

  if (isMobile || !isFeatureEnabled) {
    return null;
  }

  return (
    <div
      className="p-4 flex gap-2 justify-center items-center"
      style={{ background: "orange" }}
    >
      <span>
        {t("switchToNative")}
      </span>
    </div>
  );
};

export default SwitchToNativeBanner;
